<!-- Client header — identical structure to client-detail, no buttons -->
<div class="container-fluid header-container">
  <div class="header">
    <div class="left-info">
      <h1 class="title" (click)="onCancel()">
        <fa-icon class="back-icon" [icon]="faChevronLeft"></fa-icon>
        <span>{{ clientName() }}</span>
      </h1>

      @if (clientTypeObj()) {
        <span
          class="tag"
          [class.juridic-person-tag]="clientTypeObj().value === 'JURIDIC_PERSON'"
          [class.physical-person-tag]="clientTypeObj().value === 'PHYSICAL_PERSON'"
        >
          {{ clientTypeObj().label }}
        </span>
      }

      @if (clientRelationObj()) {
        <span
          class="tag relation-pill"
          [class.recurrent-tag]="clientRelationObj().value === 'RECURRENT'"
          [class.no-recurrent-tag]="clientRelationObj().value === 'NO_RECURRENT'"
          [class.no-client-tag]="clientRelationObj().value === 'NO_CLIENT'"
        >
          {{ clientRelationObj().label }}
        </span>
      }
    </div>
  </div>
</div>

<!-- Wizard fills remaining height -->
@if (categoria) {
  <app-operation-wizard
    [categoria]="categoria!"
    [subtipo]="subtipo"
    [clientId]="clientId"
    [existingOperation]="existingOperation()"
    (cancel)="onCancel()"
    (complete)="onComplete($event)"
  ></app-operation-wizard>
}
